module.exports = __webpack_public_path__ + "img/excel.f3db70ea.svg";